<template>
  <div class="agent_container">
    <div class="agent_top">
      <p>代理流程</p>
    </div>
    <div class="agent_bottom_img">
        <div class="jiange"></div>
        <div class="img_back">
        </div>
    </div>  
  </div>
</template>
<script type="text/ecmascript-6">
export default {};
</script>
<style lang="less" scoped>
.agent_container {
  width: 100%;
  height: 350px;
}
.agent_top {
  width: 100%;
  height: 95px;
  position: relative;
  background: #FFF7EF;
}
.agent_top > p {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(35, 35, 35, 1);
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}
.agent_bottom_img{
    width: 100%;
    background-color: #FFF7EF;
}
.img_back{
    background-image: url('../assets/代理流程图-@2x.png');
    background-size: 100%;
    height: 154px;
    background-repeat: no-repeat;
}
.jiange{
    width: 100%;
    height: 100px;
}
</style>